import React from 'react';

import appConfig from '@nerdwallet/app-config';
import { Button, Stack, Text } from '@nerdwallet/currency';
import {
  ElementImpression,
  ElementInteraction,
} from '@nerdwallet/nw-client-lib/tracking';
import { useSegmentImpressionHook } from '../../../lib/analytics/segment-impression';
import useSegmentClicked from '../../../lib/analytics/use-segment-clicked';

export interface MarketplaceCtaProps {
  title: string;
  subtitle: string;
  buttonText: string;
  url: string;
  elementName: string;
  impressionId: string;
  impressionKey: string;
  className?: string;
}

const MarketplaceCta: React.FC<MarketplaceCtaProps> = ({
  title,
  subtitle,
  buttonText,
  url,
  elementName,
  impressionId,
  className,
  impressionKey,
}) => {
  const absoluteUrl = `${appConfig.SITE_BASE_URL}${url}`;
  const { eventId: linkViewedId, ref: linkRef } = useSegmentImpressionHook({
    eventType: 'link_viewed',
    attributes: {
      entity_name: 'custom_cta',
      link_copy: buttonText,
      section_name: null,
      link_position: null,
      destination_url: absoluteUrl,
      destination_content_id: 678453,
    },
  });
  const { ref: ctaRef } = useSegmentClicked({
    attributes: {
      entity_name: 'custom_cta',
      parent_event_id: linkViewedId,
    },
  });
  return (
    <div className={className} ref={linkRef}>
      <Stack spacing="3">
        <Text size="small" bold>
          {title}
        </Text>
        <Text size="small">{subtitle}</Text>
        <ElementImpression id={impressionKey} elementName={elementName}>
          <ElementInteraction
            impressionId={impressionId}
            elementName={elementName}
            type="CLICK"
          >
            {/* This div is needed to attach the ref to Button */}
            <div>
              <Button href={url} block target="_blank" ref={ctaRef}>
                {buttonText}
              </Button>
            </div>
          </ElementInteraction>
        </ElementImpression>
      </Stack>
    </div>
  );
};

export default MarketplaceCta;
